var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrap"},[_c('div',{staticClass:"slider-wrapper"},[_c('Slider',{attrs:{"slides":_vm.slides}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }